module.exports = __webpack_public_path__ + "media/src/images/icons/close-circle-5eca4c401f3ec27830ad02dad9327ca5.svg";